import axios from 'axios';
import { getAPIHost, getExpressAPIHost } from '../../utils';
import Split from '../split';

const downloadBulkChart = (id, tank) =>
    new Promise((resolve, reject) => {
        const useExpress = Split.getBooleanTreatment('use_express_migration_endpoints');
        const host = useExpress ? getExpressAPIHost() : getAPIHost();
        // Split-gate both host AND path: Express uses /users/download-producers-bulk-chart/...;
        // LoopBack uses the un-namespaced /download-producers-bulk-chart/...
        const path = useExpress ? `/users/download-producers-bulk-chart/${id}/${tank}` : `/download-producers-bulk-chart/${id}/${tank}`;
        axios
            .get(`${host}${path}`)
            .then((response) => {
                // Express returns a JSON-quoted string filename (text/plain)
                // LoopBack returns the filename directly
                let { data } = response;
                if (useExpress && typeof data === 'string') {
                    try {
                        data = JSON.parse(data);
                    } catch (e) {
                        // keep raw string
                    }
                }
                resolve({ ...response, data });
            })
            .catch(() => {
                reject(new Error('Unable to download file'));
            });
    });

export default downloadBulkChart;
